import { get, find, toNumber, forEach, keys, isEmpty } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { ColorConfigInActive as InActiveColorLegend } from 'config/piechart-configs/resolution-config';

// import { ColorConfig } from 'config/piechart-configs/statistics-config';

/*************************************************************/

/**
 * @type {class}
 * @desc CallStatisticsReports defines an HTTP service interface to send HTTP network requests.
 * @example
 * import { CallStatisticsReportsService } from 'services/callStatisticsReports';
 *
 * // create service instance and send/cancel request
 * const callStatisticsReportsService = new CallStatisticsReportsService();
 * const result = await callStatisticsReportsService.fetchData( '<user-id>' ); // fetch data
 * callStatisticsReportsService.cancel(); // cancel an active request
 */
export class CallStatisticsReportsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const structure = get( response, 'body.component.structure', {} );
            const filterData = get( response, 'body.component.data.state', {} );
            const options = get( response, 'body.component.data.options', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    structure,
                    visibility,
                    filterData,
                    options
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data  for graphs
    async fetchGraphData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const optionKey = get( response, 'body.component.structure.reportConfig.options', '' );
            const structure = get( response, 'body.component.structure', {} );
            
            // extract data
            const options = get( response, 'body.component.data.state.options', {} )[ optionKey ];
            const value = get( response, 'body.component.data.state.values', {} );

            // modify data for bar graphs
            const graphData = [];

            if( ! isEmpty( value ) ) {
                forEach( keys( value ), key => {
                    graphData.push( {
                        name: find( options, { 'value': key } ).name,
                        id: find( options, { 'value': key } ).value,
                        value: toNumber( get( get( value, key, {} ), 'value' ) ),
                        labelText: `${ get( get( value, key, {} ), 'value' ) } (${ get( get( value, key, {} ), 'percentageValue' ) }%)`
                    } );
                } );
            }

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    config: structure,
                    chartData: graphData,
                    totalCalls: get( response, 'body.component.data.state.totalCalls', {} )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data  for graphs
    async fetchChartData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data from the response
            const optionKey = get( response, 'body.component.structure.reportConfig.options', '' );
            const structure = get( response, 'body.component.structure', {} );
            
            // extract data
            const options = get( response, 'body.component.data.state.options', {} )[ optionKey ];
            const value = get( response, 'body.component.data.state.values', {} );

            // modify data for bar graphs
            const graphData = [];

            forEach( keys( value ), ( key, index ) => {

                const selOption  = find( options, { 'value': key } );
                graphData.push( {
                    
                    // name: get( selOption, 'value' ),
                    // id: get( selOption, 'value' ),
                    // value: toNumber( get( get( value, key, {} ), 'value' ) ),
                    // tooltip: `${ get( selOption, 'name' ) } (${ get( get( value, key, {} ), 'percentageValue' ) }%)`,

                    name: get( selOption, 'name' ),
                    percentageValue: get( get( value, key, {} ), 'percentageValue' ) +'%',
                    y: toNumber( value[ key ].value ),
                    color: InActiveColorLegend[ index ]
                } );
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    config: structure,
                    chartData: graphData,
                    totalCalls: get( response, 'body.component.data.state.totalCalls', {} ),
                    categoryName: get( response, 'body.component.data.state.categoryName', {} ),
                },
            };
        } catch( error ) {

            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
